module.exports = __webpack_public_path__ + "static/img/7.a9343d5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/4/sp/7.png
// module id = JGZO
// module chunks = 0